import axios from "@/libs/api.request";
// 获取列表
export const getList = params => {
  return axios.request({
    url: "/extract/clearance/index",
    params,
    method: "get"
  });
};
// 创建列表
export const save = data => {
  return axios.request({
    url: "/extract/clearance/save",
    data,
    method: "post"
  });
};
// 删除列表
export const del = data => {
  return axios.request({
    url: `/extract/clearance/delete/${data.id}`,
    method: "post",
  });
};

export const getConfig = data => {
  return axios.request({
    url: `/extract/clearance/conf`,
    method: "get",
  });
};

export const expenseItem = data => {
  return axios.request({
    url: `/common/expenseItem`,
    method: "get",
  });
};